module.exports = __webpack_public_path__ + "static/media/logo-vanity.55c640d1.png";